import React, {useContext, useEffect, useState} from 'react';
import {Col, Container, Form, FormControl, InputGroup, Row} from "react-bootstrap";
import {EntityAccountsComponent} from "../../../components/entity-accounts/EntityAccountsComponent";
import {dateToString, getCurBusDate, getMinPermissibleBusDate, pickerDateFormatToDate} from "../../../utils/FormatUtils";
import {getAllErrorValuesAsString, filterFormErrors} from "../../../utils/ErrorUtils";
import {SWIFT_MESSAGE_URL_SEARCH} from "../../../service/UrlConstant";
import {SecurityContext} from "../../../context/security";
import {SwiftMessageContext} from "./context";
import {EntityAccountsContext} from "../../../components/entity-accounts/context";
import {ToastContext} from "../../../context/Toast";
import {normaliseFilterValueAllToEmptyString} from "../../../utils/StringUtils";
import {FilterContext} from "../../../layouts/SidePanelLayout";


export default function SwiftMessageFilter() {

    const {setSwiftMessageSearchDisplayState,showSearch,swiftMessageState,setSwiftMessageState,clearSwiftMessageState, clearSwiftMessageSearchDisplayState} = useContext(SwiftMessageContext);
    const {handlePageRequest,setPanelDisplayState,getErrorInitState} = useContext(SwiftMessageContext);
    const {entityAccountsNoSwap,setShowAccounts,entityAccountsOptionsNoSwap, clearEntityAccounts,validateEntityAccountSearch, paramBadgeInfo, populateDefaultEntity, setShowAccountValidateAccount} = useContext(EntityAccountsContext);
    const {resetFlagLeft} = useContext(SecurityContext);
    const {makePostRequest} = useContext(SecurityContext);
    const {success,error} = useContext(ToastContext);
    const [formErrors, setFormErrors] = useState(getErrorInitState());
    const [accountOptional, setAccountOptional] = useState(true);
    const {showFilter, setShowFilter} = useContext(FilterContext);

    const handleSearchClick = (e) => {
        e.preventDefault();
        const errors = validateSearch()
        const newFormErrors = {...formErrors,...{'search':errors}}
        setFormErrors(newFormErrors)
        if(Object.keys(errors).length > 0){
            return
        }
        const searchCriteria =  {

            'indDirection': normaliseFilterValueAllToEmptyString(swiftMessageState.search.direction),
            'indProcessCltTrade': normaliseFilterValueAllToEmptyString(swiftMessageState.search.processed),
            'cdMtMsgType':normaliseFilterValueAllToEmptyString(swiftMessageState.search.messageType),
            "effectiveDate": dateToString(swiftMessageState.search.date)
        }

        setShowFilter(!showFilter)

        const onSuccessResponse = (response) => {
            const shortSwiftMessageSearchDisplayDetails = {
                resData : response.data,
                searchCriteria : searchCriteria
            }
            setSwiftMessageSearchDisplayState(shortSwiftMessageSearchDisplayDetails);
            swiftMessageState['currentPage'] = 'search';
            setPanelDisplayState({...swiftMessageState});
        }

        const onErrorResponse = (err) => {
            let errorMsg = getAllErrorValuesAsString(err.response.data)
            console.error("Error occured in processing",errorMsg);
            error("Error occured in processing. " + errorMsg);
        }

        makePostRequest(searchCriteria,
            SWIFT_MESSAGE_URL_SEARCH , onSuccessResponse, onErrorResponse);

    };

    const handleSearchClear = (e) => {
        clearSwiftMessageState();
        clearEntityAccounts(true,false, true);
        clearSwiftMessageSearchDisplayState()
        setFormErrors(getErrorInitState());
        handlePageRequest('defaultlanding');
    }

    const validateSearch = ()=>{
        let errors = {}

        const {date, status, direction, messageType} = swiftMessageState.search;

        if (!date)
            errors['date'] = 'Please enter search date'


        if (date && (dateToString(date) < getMinPermissibleBusDate()))
            errors['date'] = `Please ensure that the start date is on or after ${pickerDateFormatToDate(getMinPermissibleBusDate())}`;

        if (date &&  (dateToString(date) > getCurBusDate()))
            errors['date'] = `Please ensure that the start date is on or before ${pickerDateFormatToDate(getCurBusDate())}`;

        if (!direction || direction.trim().length === 0) {
            errors['direction'] = 'Direction is required';
        }

        if (!messageType || messageType.trim().length === 0) {
            errors['direction'] = 'Direction is required';
        }

        return errors
    }

    const handleSearchOnChange = (e) => {
        const targetName = e.currentTarget.name;
        const targetValue = e.currentTarget.value;
        const swiftMessageNewState = {...swiftMessageState}
        swiftMessageNewState['search'][e.currentTarget.name] = e.currentTarget.value;
        setSwiftMessageState(swiftMessageNewState);
        filterFormErrors(targetName, targetValue,
            formErrors, setFormErrors,swiftMessageState.search)
    }
/*
    useEffect(() => {
        setShowAccounts(showSearch,true);
        populateDefaultEntity(showSearch,true);
    }, [entityAccountsOptionsNoSwap])

    useEffect(()=>{
        setShowAccountValidateAccount(showSearch, false,true);
    },[]);

 */


    return(<>
        <Container fluid className="mt-md-3 mt-sm-0">
            <Form className={'mt-4'} onSubmit={(e) => e.preventDefault()}>
                <h2 className="d-none d-md-block">Search</h2>
                <Row>

                    <Col sm={12} md={12} className={'py-0'}>
                        <Form.Group controlId="swiftMessageState.search.date">
                            <Form.Label className="filter-input-label"> Date </Form.Label>
                            <Form.Control type="date" name="date" value={swiftMessageState.search.date} onChange={handleSearchOnChange} isInvalid={!!formErrors.search.date}/>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.search.date}</b></Form.Control.Feedback>

                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group controlId="formGridProcessed" className={'td-select'} >
                            <Form.Label className="filter-input-label">Processed</Form.Label>
                            <Form.Control as="select" name="processed"
                                          value={swiftMessageState.search.processed}
                                          onChange={handleSearchOnChange}
                                          isInvalid={!!formErrors.processed}>
                                <option value='ALL'>ALL</option>
                                <option value='Y'>YES</option>
                                <option value='N'>NO</option>
                            </Form.Control>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.search.processed}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group controlId="formGridDirection" className={'td-select'} >
                            <Form.Label className="filter-input-label">Direction</Form.Label>
                            <Form.Control as="select" name="direction"
                                          value={swiftMessageState.search.direction}
                                          onChange={handleSearchOnChange}
                                          isInvalid={!!formErrors.direction}>
                                <option value='ALL'>ALL</option>
                                <option value='OUT'>OUT</option>
                                <option value='IN'>IN</option>
                            </Form.Control>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.search.direction}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group controlId="formGridMsgType" className={'td-select'} >
                            <Form.Label className="filter-input-label">Msg Type</Form.Label>
                            <Form.Control as="select" name="messageType"
                                          value={swiftMessageState.search.messageType}
                                          onChange={handleSearchOnChange}
                                          isInvalid={!!formErrors.messageType}>
                                <option value='ALL'>ALL</option>
                                <option value='103'>MT103</option>
                                <option value='202'>MT202</option>
                                <option value='210'>MT210</option>
                                <option value='900'>MT900</option>
                                <option value='910'>MT910</option>
                                <option value='199'>MT199</option>
                                <option value='540'>MT540</option>
                                <option value='541'>MT541</option>
                                <option value='542'>MT542</option>
                                <option value='543'>MT543</option>
                                <option value='544'>MT544</option>
                                <option value='545'>MT545</option>
                                <option value='546'>MT546</option>
                                <option value='547'>MT547</option>
                                <option value='548'>MT548</option>
                            </Form.Control>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.search.messageType}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-primary-light my-3" type='submit'
                                onClick={handleSearchClick}>Search
                        </button>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-secondary-clear my-3" onClick={handleSearchClear}>Clear</button>
                    </Col>
                </Row>
            </Form>
        </Container>
    </>)

}